import React, { ComponentType, SVGProps, useState } from 'react'
import { makeStyles } from '@mui/styles'
import { ButtonIconSquare } from '@/modules/base/components/buttons'
import CascadingContextMenu from '@/modules/base/components/cascading-context-menu/cascading-context-menu'

export interface CascadingContextMenuItem {
  label: string,
  key: string,
  onClick: () => void,
  icon?: string | ComponentType<SVGProps<SVGSVGElement>>,
  children?: CascadingContextMenuItem[],
}

const useStyles = makeStyles(() => ({
  cascadingMenuButton: {
    flexGrow: 1,
    display: 'flex',
    justifyContent: 'flex-start',
  },
}))

type CascadingMenuButtonProps = {
  menuItems: CascadingContextMenuItem[],
  label: string,
  icon?: string,
}

const CascadingMenuButton = (props: CascadingMenuButtonProps) => {
  const { menuItems, label, icon } = props
  const classes = useStyles(props)

  const [position, setPosition] = useState(null)

  const openMenu = (event) => {
    if (position) {
      return
    }

    const { left, top } = event.target.getBoundingClientRect()
    setPosition({
      left: left + 15,
      top: top + 10,
    })
  }

  return (
    <div className={classes.cascadingMenuButton}>
      <CascadingContextMenu
        disabled
        vertical='bottom'
        killed={!position}
        horizontal={'center'}
        onClose={() => setPosition(null)}
        menuItems={menuItems}
        position={position}
        closeOnClick>
        <ButtonIconSquare onClick={openMenu} label={label} icon={icon} variant={'outline'} />
      </CascadingContextMenu>
    </div>
  )
}

export default CascadingMenuButton
